import { styling } from '../core/styling.js';

const cursor = styling({
    $cursor: {
        type: 'string',
        properties: ['cursor'],
    },
});

export { cursor };
//# sourceMappingURL=cursor.js.map
